import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import 'store/customTracking';
// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {

}
